import { render, staticRenderFns } from "./MainSidebarHeader.vue?vue&type=template&id=0a99f5d0&scoped=true"
import script from "./MainSidebarHeader.vue?vue&type=script&lang=js"
export * from "./MainSidebarHeader.vue?vue&type=script&lang=js"
import style0 from "./MainSidebarHeader.vue?vue&type=style&index=0&id=0a99f5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99f5d0",
  null
  
)

export default component.exports